import React from 'react';

export const FormInput = ({ className, ...props }: React.HTMLProps<HTMLInputElement>) => {
  const inputClassName = `
    form-input font-hurmegeometric-sans bg-white mt-[5px] block border border-solid border-gray-17 
    text-black-legacy w-full box-border p-[10px] disabled:bg-gray-light placeholder:text-gray-legacy
    ${className ?? ''}
  `;
  return (
    <input className={inputClassName} {...props} />
  )
}
